<template>
  <div class="row">
    <div class="col-12">
      <div class="pane-header">
        <span class="icon">
          <slot name="icon" />
        </span>
        <span class="text">{{ capitalize(chartName) }}</span>
      </div>
    </div>
    <div class="col-12">
      <div
        v-if="isLoading"
        class="pane-content pad-top">
        <loader-small />
      </div>
      <div
        v-else-if="showChart"
        class="pane-content pad-top chart-container">
        <chart
          :template-ref="templateRef"
          :name="chartName"
          :mode="chartMode"
          :actions="chartActions"
          :echarts-options="chartOptions"
          :show-future="false"
          :theme="chartTheme" />
      </div>
      <div
        v-else
        class="pane-content pad-top">
        {{ capitalize($t('messages.noResultsFound')) }}
      </div>
    </div>
  </div>
</template>

<script setup>
  import { capitalize, defineAsyncComponent } from 'vue';

  import { LoaderSmall } from '@/common/components/controls';
  import ChartMode from '@/common/enums/chart-mode.enum';
  import ChartTheme from '@/common/enums/chart-theme.enum';

  const Chart = defineAsyncComponent(() => import('@/common/components/chart/Chart'));
  //
  // Props
  //
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const props = defineProps({
    chartName: { type: String, required: true, default: null },
    chartMode: { type: String, default: ChartMode.COMPACT },
    chartTheme: { type: String, default: ChartTheme.ONE_TONE_BLUE },
    chartOptions: { type: Object, default: null },
    chartActions: { type: Array, required: true, default: () => [] },
    isLoading: { type: Boolean, required: true, default: false },
    showChart: { type: Boolean, required: true, default: false },
    templateRef: { type: String, required: true, default: null },
  });
</script>

<style scoped>
  #package_details {
    .chart-container {
      height: 30rem;
      display: flex;
      flex-direction: column;
      align-items: center;
      position: relative;
    }
    .icon {
      margin: auto auto auto 1rem;
      height: 2.4rem;
      width: 2.4rem;
      opacity: 0.4;
      fill: var(--iconColorDark);
      stroke: var(--iconColorDark);
    }
  }
</style>
